import React, { useState, useEffect } from "react";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import Col from "react-bootstrap/Col";
import Container from "react-bootstrap/Container";
import Modal from "react-bootstrap/Modal";
import Row from "react-bootstrap/Row";
import Spinner from "react-bootstrap/Spinner";
import { inviteUser } from "../../../../services/api/user-api";
import PropTypes from "prop-types";
import "./admin-user-invite-modal.scss";

const isValidEmail = (email) =>
    /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i.test(email);

const Email = (props) => {
    const { onChange, value, isInvalid, } = props;
    return (
        <div className="invite-team-email-container">
            <Row className="invite-team-email">
                <Col>
                    <Form.Group noValidate>
                        <Form.Label>Email address</Form.Label>
                        <Form.Control className="email-input input"
                            type="text"
                            as="input"
                            value={value}
                            placeholder="example@triyosoft.com"
                            onChange={(e) => onChange(e.target.value)}
                            isInvalid={isInvalid}
                            required
                            autoComplete="off"
                        />
                        <Form.Control.Feedback type="invalid">
                            Please provide a valid email address.
                        </Form.Control.Feedback>
                    </Form.Group>
                </Col>
            </Row>
        </div>
    );
}

const AdminUserInviteModal = ({dynData, IsModalOpened, onAfterOpen, onCloseModal}) => {
    const [emailAddress, setEmailAddress] = useState("");
    const [isPending, setIsPending] = useState(false);
    const [validate, setValidate] = useState(false);
    const [emailInvitationIsValid, setEmailInvitationIsValid] = useState();
    const isInvalid = validate && !isValidEmail(emailAddress);

    const afterOpenModal = (e) => {
        onAfterOpen(e, "After Modal Opened");
    }

    const handleEmailInvitation = async(e) => {
        setValidate(true);
        if (emailInvitationIsValid) {
            try {
                await inviteUser(emailAddress);
                return emailInvitationIsValid;
            } catch (error) {
                return false;
            }
        }
    }

    const onModalClose = async(event, type) => {
        let data;
        if (type === "close") {
            data = { email: emailAddress, type: "close" };
            onCloseModal(event, data);
            setValidate(false);
            setEmailAddress("");
        } else if (type === "send") {
            setIsPending(true);
            const result = await handleEmailInvitation();
            setIsPending(false);
            if (result === true) {
                data = { email: emailAddress, type: "success" };
                if(emailInvitationIsValid) {
                    onCloseModal(event, data);
                    setValidate(false);
                    setEmailAddress("");
                }
            } else if (result === false) {
                data = { email: emailAddress, type: "error" };
                if (emailInvitationIsValid) {
                    onCloseModal(event, data);
                    setValidate(false);
                    setEmailAddress("");
                }
            }
        }
    }

    const validator = () => {
        setEmailInvitationIsValid(isValidEmail(emailAddress));
    };

    useEffect(() => {
        validator();
    })

    return (
        <Modal contentClassName="modal-styles" className="invite-modal"
            show={IsModalOpened}
            onAfterOpen={e => afterOpenModal(e)}
            ariaHideApp={false}
        >
            <Modal.Header>
                <h4 className="header">Invite a user</h4>
            </Modal.Header>
            <Modal.Body>
                <Container className="modal-body-container">
                    <Row className="modal-body-container-row">
                        <Col>
                            <Form.Group noValidate validated={validate}>
                                <Email value={emailAddress} onChange={setEmailAddress}
                                    isInvalid={isInvalid}
                                />
                            </Form.Group>
                        </Col>
                    </Row>
                </Container>
            </Modal.Body>
            <Modal.Footer>
                <Button className="close-button" onClick={(e) => onModalClose(e, "close")} >
                    Close
                </Button>
                <Button className={`send-invitation-button ${(isPending || isInvalid)? "disabled" : ""}`} type="submit"
                    disabled={isPending || isInvalid}
                    onClick={(e) => onModalClose(e, "send")}
                >
                    {isPending && <Spinner className="send-invitation-spinner" as="span" animation="border" size="sm" role="status" />}
                    Send invitation
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

AdminUserInviteModal.propTypes = {
    dynData: PropTypes.object,
    IsModalOpened: PropTypes.bool.isRequired,
    onAfterOpen: PropTypes.func.isRequired,
    onCloseModal: PropTypes.func.isRequired
}

export default AdminUserInviteModal;